import React from 'react';
import { Forms, SystemText } from 'e4shared';

export const CourseCompletionField = ({ field, onChange, sortedCourses, statuses }) => {
    const [values, setValues] = React.useState(field.value);

    const updateValues = newValues => {
        const temp = [...newValues];
        onChange?.(temp);
    };

    React.useEffect(() => {
        if (field.value) {
            setValues(field.value);
        }
    }, [field?.value]);

    const addNew = () => {
        const temp = [...values].concat([{ id: null, status: [] }]);
        updateValues(temp);
    };

    const coursePlaceholderText = SystemText('General/Controls/Filters/Course/Placeholder');
    const statusPlaceholderText = SystemText('General/Controls/Filters/Course/Status/Placeholder');
    const addText = SystemText('General/Controls/Filters/Add');
    const isText = SystemText('General/Controls/Filters/Course/Is');

    return (
        <div>
            {values.map((value, i) => {
                const setCourseId = (i, x) => {
                    const temp = [...values];
                    const curr = temp[i];
                    curr.id = x;
                    updateValues(temp);
                };

                const setStatus = (i, x) => {
                    const temp = [...values];
                    const curr = temp[i];
                    curr.status = x;
                    updateValues(temp);
                };

                return (
                    <div key={`course-filter-${values.id || 0}-${i}`}>
                        <div>
                            <Forms.Select
                                i
                                data={sortedCourses}
                                value={value.id}
                                onChange={x => setCourseId(i, x)}
                                placeholder={coursePlaceholderText}
                                mandatory
                            />
                        </div>
                        <div className="behaviour-score ml3 mt5">{isText}</div>
                        <div className="mt10 mb10">
                            <Forms.Select
                                data={statuses}
                                value={value.status}
                                onChange={x => setStatus(i, x)}
                                placeholder={statusPlaceholderText}
                                mandatory
                                allowMultiple
                            />
                        </div>
                    </div>
                );
            })}
            <div className="ml3">
                <button className="btn btn-link text-primary" onClick={addNew}>
                    <i className="fa fa-plus-circle mr10" />
                    {addText}
                </button>
            </div>
        </div>
    );
};

export default CourseCompletionField;
